import React from 'react'
import { Box } from "native-base"

export const Card = ({ children }: { children: React.ReactNode }) => (
  <Box _dark={{ bg: "black.800" }} _light={{ bg: "white.100" }} borderRadius={10} p={5} shadow={2}>
    {children}
  </Box>
);
